import { Plugin } from '../renderer';
export class ComponentProcessor extends Plugin {
}
//# sourceMappingURL=processor.js.map